let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bbWER")).then(() => parcelRequire('21sJm'));